module.exports = __webpack_public_path__ + "img/pic_cz.2d1f5feb.png";